
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import orderBy from 'lodash/orderBy';

import { DialogAlert, IfComp, PanelSectionTitle } from '../../core';
import { useDisableEditMsg } from '../../project';

import { getActions } from '../sagas';
import { getDataModelDefinition } from '../reducers'

const CreateNewObjectItem = ({dataActions, dataModelItem}) => {

    const disableEditMsg = useDisableEditMsg();

    const handleClick = () => {
        if (!disableEditMsg) {
            dataActions.setObjectCreate(dataModelItem);
        } else {
            DialogAlert.show(disableEditMsg);
        }
    }

    const getTitle = () => {
        let title = `${dataModelItem.title}`;
        return title;
    }

    return (dataModelItem)
        ? <Link onClick={handleClick}>{getTitle()}</Link>
        : null;
}

const CreateNewObjectItemList = ({dataActions, items}) => {

    return items.map(item => {
        return (
            <CreateNewObjectItem
                dataActions={dataActions}
                dataModelItem={item}
                key={item.id}
            />
        );
    })
}

const CreateNewObject = () => {

    const classNames = mergeStyleSets({
        CreateNewObject: {
        },
    });

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);

    const dataModelDefinition = useSelector(state => getDataModelDefinition(state.data));

    let createNewObjectItems = dataModelDefinition.dataModelDefinition.items.reduce((previous, current) => {
        if (current.operations.insert && (current.$template !== true)) {
            previous.push(current);
        }
        return previous;
    }, []);

    createNewObjectItems = orderBy(createNewObjectItems, ['title']);

    return (
        <Stack verticalFill className={classNames.CreateNewObject} tokens={{childrenGap: 4}}>
            <PanelSectionTitle title="Vytvoření nového objektu" />
            <IfComp cond={(createNewObjectItems.length > 0)}>
                <CreateNewObjectItemList
                    dataActions={dataActions}
                    items={createNewObjectItems}
                />
            </IfComp>
            <IfComp cond={(createNewObjectItems.length === 0)}>
                <div>- není dostupný žádný typ objektu pro vytvoření</div>
            </IfComp>
        </Stack>
    );
}

export default CreateNewObject;
